export default __webpack_public_path__ + "static/media/review-item.f60f0fc1.svg";